/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Mulai_Cta_NoteInputs */

const en_simple_mulai_cta_note = /** @type {(inputs: Simple_Mulai_Cta_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free for your first plan.`)
};

const id_simple_mulai_cta_note = /** @type {(inputs: Simple_Mulai_Cta_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis untuk membuat rencana pertama.`)
};

/**
* | output |
* | --- |
* | "Free for your first plan." |
*
* @param {Simple_Mulai_Cta_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_mulai_cta_note = /** @type {((inputs?: Simple_Mulai_Cta_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Mulai_Cta_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_mulai_cta_note(inputs)
	return en_simple_mulai_cta_note(inputs)
});